import { useEffect, useState } from "react";
import { Search } from "lucide-react";
import { api, eur } from "@/lib/api";
import { PageHeader, Empty } from "@/components/Common";
import { Input } from "@/components/ui/input";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { ScanButton } from "@/components/BarcodeScanner";

const qty = (n) => Number(n || 0).toLocaleString("it-IT", { maximumFractionDigits: 3 });

export default function Catalogo() {
  const [items, setItems] = useState(null);
  const [giac, setGiac] = useState(null);
  const [q, setQ] = useState("");
  useEffect(() => {
    api.get("/products").then((r) => setItems(r.data));
    api.get("/magazzino/giacenze").then((r) => setGiac(Object.fromEntries(r.data.righe.map((x) => [x.product_id, x])))).catch(() => setGiac(false));
  }, []);
  if (!items) return null;
  const rows = items.filter((p) => !q || `${p.codice} ${p.descrizione} ${p.barcode || ""}`.toLowerCase().includes(q.toLowerCase()));
  return (
    <div>
      <PageHeader title="Catalogo e giacenze" subtitle={giac === false ? "Articoli e prezzi (magazzino non attivo)" : "Articoli, prezzi e quantit\u00e0 disponibili in magazzino"} />
      <div className="mb-4 flex max-w-xl gap-2">
        <div className="relative flex-1">
          <Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400" />
          <Input data-testid="catalog-search-input" placeholder="Cerca codice, descrizione o codice a barre" className="h-11 bg-white pl-9" value={q} onChange={(e) => setQ(e.target.value)} />
        </div>
        <ScanButton onCode={setQ} testid="catalog-scan-button" />
      </div>
      {rows.length === 0 ? <Empty text="Nessun articolo trovato" /> : (
        <div className="overflow-x-auto rounded-xl border border-slate-200 bg-white">
          <Table>
            <TableHeader><TableRow><TableHead>Codice</TableHead><TableHead>Descrizione</TableHead><TableHead className="text-right">Prezzo</TableHead><TableHead className="text-right">IVA</TableHead>{giac && <TableHead className="text-right">Giacenza</TableHead>}</TableRow></TableHeader>
            <TableBody>
              {rows.map((p) => {
                const g = giac && giac[p.id];
                const low = g && p.a_magazzino && g.giacenza <= (g.scorta_minima || 0);
                return (
                  <TableRow key={p.id} data-testid={`catalog-row-${p.id}`}>
                    <TableCell className="font-mono text-sm">{p.codice}</TableCell>
                    <TableCell className="text-sm">{p.descrizione}</TableCell>
                    <TableCell className="text-right font-mono text-sm">{eur(p.prezzo)}</TableCell>
                    <TableCell className="text-right text-sm">{p.natura || `${p.aliquota}%`}</TableCell>
                    {giac && <TableCell className={`text-right font-mono text-sm font-semibold ${low ? "text-rose-600" : "text-slate-900"}`}>{p.a_magazzino && g ? `${qty(g.giacenza)} ${p.unita || ""}` : "\u2014"}</TableCell>}
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </div>
      )}
    </div>
  );
}
